import { ReactNode, useState } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCopy } from "@fortawesome/free-solid-svg-icons";

// ----------------------- COPY BUTTON ------------------------------------
export function CopyValue({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };
  return (
    <button type="button" onClick={copy} aria-label="Copy" className={clsx("ml-2 text-[11px] transition-colors", copied ? "text-emerald-500" : "text-label-muted hover:text-heading-color")}>
      <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
    </button>
  );
}

// ----------------------- LABEL / VALUE GRID ------------------------------------
export function Fields({ rows }: { rows: [string, ReactNode, string?][] }) {
  return (
    <dl className="glass divide-y divide-edge overflow-hidden p-0">
      {rows.map(([label, value, copy]) => (
        <div key={label} className="grid grid-cols-[130px_1fr] gap-3 px-4 py-2.5 text-[13px]">
          <dt className="font-[Gilroy-Medium] text-label-muted">{label}</dt>
          <dd className="flex min-w-0 items-center break-all font-[Gilroy-Medium] text-heading-color">
            {value ?? <span className="text-label-muted">—</span>}
            {copy ? <CopyValue value={copy} /> : null}
          </dd>
        </div>
      ))}
    </dl>
  );
}

// ----------------------- PRETTY JSON ------------------------------------
export function JsonView({ title, value }: { title: string; value: unknown }) {
  if (value == null || (typeof value === "object" && !Object.keys(value as object).length)) return null;
  const text = JSON.stringify(value, null, 2);
  return (
    <div className="overflow-hidden rounded-2xl border border-edge">
      <div className="flex items-center justify-between bg-overlay px-4 py-2 font-[Gilroy-Medium] text-[12px] text-light-gray">
        {title}
        <CopyValue value={text} />
      </div>
      <pre className="custom-scrollbar max-h-[320px] overflow-auto bg-[#0b1020] p-4 font-mono text-[12px] leading-relaxed text-indigo-100">{text}</pre>
    </div>
  );
}

// ----------------------- PANEL SECTION TITLE ------------------------------------
export function PanelTitle({ children }: { children: ReactNode }) {
  return <p className="font-[Gilroy-Bold] text-[13px] uppercase tracking-wide text-label-muted">{children}</p>;
}
